<template>
    <div class="tx-history-wrap">
        <table class="ui-table">
            <thead v-if="addressList.length > 0">
                <tr>
                    <th style="max-width: none;">{{ $t('common.address') }}</th>
                </tr>
            </thead>
            <template v-if="addressList && addressList.length > 0 && !isLoading">
                <tbody v-for="(item, i) in addressList" v-bind:key="`addressList_${item}`">
                    <tr>
                        <td style="max-width: none;">
                            <ui-address v-bind:address="item" />
                            <span v-if="isSigned(i)" class="vesting-sender">Signed</span>
                        </td>
                    </tr>
                </tbody>
            </template>
            <template v-else-if="addressList && addressList.length === 0 && !isLoading">
                <div class="tx-history-empty-panel">
                    {{ $t('multisig.addresslist_empty') }}
                </div>
            </template>
            <template v-else>
                <tbody v-for="i in 8" v-bind:key="`addressList_skeleton_${i}`">
                    <td v-pre>
                        <span class="tx-table-cell-skeleton" style="width: 100%;"></span>
                    </td>
                </tbody>
            </template>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        addressList: Array,
        approvalsMask: Number,
        isLoading: Boolean,
    },

    methods: {
        isSigned(i) {
            const mask = 1 << i; // eslint-disable-line "no-bitwise"
            return this.approvalsMask & mask; // eslint-disable-line "no-bitwise"
        },
    },
};
</script>

<style lang="scss">

</style>
